/**
 * Redline: restrict storefront search to product titles only.
 * - As-you-type dropdown (predictive search)
 * - Pressing Enter in the search box
 * - "View all" button and the search page form
 */
(function () {
  var FIELD_PARAMS = {
    type: 'product',
    'options[fields]': 'title',
    'options[prefix]': 'last'
  };

  // 1. Predictive search: only products, matched on title
  try {
    if (window.Theme && Theme.routes && Theme.routes.predictive_search_url &&
        Theme.routes.predictive_search_url.indexOf('resources') === -1) {
      Theme.routes.predictive_search_url +=
        '?resources[type]=product&resources[options][fields]=title&resources[options][prefix]=last';
    }
  } catch (e) {}

  // 2. Every search form submits a title-only product search
  function addHiddenInputs(form) {
    Object.keys(FIELD_PARAMS).forEach(function (name) {
      if (form.querySelector('input[name="' + name + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = FIELD_PARAMS[name];
      form.appendChild(input);
    });
  }

  function prepareForms() {
    document.querySelectorAll('form[action$="/search"]').forEach(addHiddenInputs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareForms);
  } else {
    prepareForms();
  }

  // 3. Enter key in the search modal goes to a title-only results page
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'q') return;
    var component = input.closest('predictive-search-component');
    if (!component) return;
    if (component.querySelector('[aria-selected="true"]')) return;
    if (component.querySelector('[data-single-result-url]')) return;
    var term = input.value.trim();
    if (!term) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var base = (window.Theme && Theme.routes && Theme.routes.search_url) || '/search';
    var url = new URL(base, location.origin);
    url.searchParams.set('q', term);
    Object.keys(FIELD_PARAMS).forEach(function (name) {
      url.searchParams.set(name, FIELD_PARAMS[name]);
    });
    window.location.href = url.toString();
  }, true);
})();
